module.exports = __webpack_public_path__ + "static/exploring-historic-dutch-new-york-ca500d55ad66f2498fad46dccf108856.jpg";